import { QueryClient } from '@tanstack/react-query';

// Create a client
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // The time in milliseconds after data is considered stale
      staleTime: 5 * 60 * 1000, // 5 minutes
      // The time in milliseconds that unused/inactive cache data remains in memory
      gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
      // Retry failed requests
      retry: (failureCount, error: any) => {
        // Don't retry on 401/403 errors (authentication issues)
        if (error?.status === 401 || error?.status === 403) {
          return false;
        }
        // Retry other errors up to 3 times
        return failureCount < 3;
      },
      // DON'T set global refetch settings - let individual queries control this
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    },
    mutations: {
      // Don't retry mutations - show errors immediately
      retry: false,
    },
  },
});

